import { environment } from '../../environments/environment'

const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i

/**
 * Reduces a fileId to its object-key UUID. Plain UUIDs pass through unchanged;
 * URL-shaped values (banner endpoints embed presigned URLs in fileId fields)
 * are reduced to the UUID they carry. Returns null when nothing usable remains.
 */
export function resolveFileId(raw: string | null | undefined): string | null {
	if (!raw) return null
	if (!/^https?:/i.test(raw)) return raw
	return raw.match(UUID_PATTERN)?.[0] ?? null
}

/**
 * Stable public URL for a stored file: `{filesBaseUrl}/{fileId}`. The object name
 * in SeaweedFS is the fileId UUID and the bytes never change under it, so the URL
 * is deterministic and served with `immutable` cache headers — no presign call.
 */
export function fileUrl(raw: string | null | undefined): string | null {
	const id = resolveFileId(raw)
	return id ? `${environment.filesBaseUrl}/${id}` : null
}
